import { render, staticRenderFns } from "./NewFolderButtonV2.vue?vue&type=template&id=41c8966c&scoped=true"
import script from "./NewFolderButtonV2.vue?vue&type=script&lang=js"
export * from "./NewFolderButtonV2.vue?vue&type=script&lang=js"
import style0 from "./NewFolderButtonV2.vue?vue&type=style&index=0&id=41c8966c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c8966c",
  null
  
)

export default component.exports